module.exports = __webpack_public_path__ + "static/media/088-uruguay.d0abf516.svg";